import { Data2, useDataTypesHooks } from "../../../features/data-types"
import { Currency, TableName } from "../../../tables/types/types"
import { useBudgetBuilders } from "../builders/budgetBuilders"
import { useBudgetActions } from "../actions/budgetActions"
import { useSaleOperationService } from "./sale-operation-service/saleOperationService"

export const useBudgetService = () => {
    const { generateCode } = useDataTypesHooks()

    const { buildBudget } = useBudgetBuilders()

    const { buildSaleOperationItems } = useSaleOperationService()
    const { saveBudget } = useBudgetActions()

    const createBudget = async (
        budgetData: Data2,
        itemsData: Data2[]
    ) => {
        const code = await generateCode(TableName.BUDGETS)
        const items = buildSaleOperationItems(itemsData, budgetData.customerTypeId! as string)
        const budget = buildBudget({
            ...budgetData,
            code,
            items,
            currency: Currency.ARS
        })

        return saveBudget(budget)
    }

    return {
        createBudget
    }
}
